import { render, staticRenderFns } from "./preloader.vue?vue&type=template&id=2e18edd6&"
import script from "./preloader.vue?vue&type=script&lang=js&"
export * from "./preloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src271809469/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e18edd6')) {
      api.createRecord('2e18edd6', component.options)
    } else {
      api.reload('2e18edd6', component.options)
    }
    module.hot.accept("./preloader.vue?vue&type=template&id=2e18edd6&", function () {
      api.rerender('2e18edd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/sections/preloader/preloader.vue"
export default component.exports